module.exports = __webpack_public_path__ + "static/media/facebook_reaction_haha.6b8bdfd9.svg";